import React, { useState } from 'react';
import styles from './Components/CSS/ReadMoreSeries.module.css';
import { useSeriesByType } from '../hooks/useSeriesData';

const ReadMoreSeries = () => {
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10; // Using the per_page value from the API

  const {
    series,
    pagination,
    isLoading,
    error
  } = useSeriesByType('Audio', currentPage, itemsPerPage);

  // Handle page change
  const nextPage = () => {
    if (pagination && currentPage < pagination.pages) {
      setCurrentPage(currentPage + 1);
    }
  };

  const prevPage = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };

  // Show loading state
  if (isLoading) {
    return <div className={styles.loadingContainer}>
      <div className={styles.loadingSpinner}></div>
    </div>;
  }

  // Show error state
  if (error) {
    return <div className={styles.errorContainer}>
      <p>Error loading series: {error.message}</p>
    </div>;
  }

  return (
    <div className={styles.container}>
      <div className={styles.boxContainer}>
        <h1 className={styles.title}>Start with these</h1>
        
        <div className={styles.gridContainer}>
          {series && series.map((item) => (
            <div key={item.id} className={styles.gridItem}>
              <div className={styles.imageContainer}>
                <img 
                  src={item.coverImageUrl} 
                  alt={item.title} 
                  className={styles.image} 
                  onError={(e) => {
                    e.target.src = 'https://via.placeholder.com/150/000000/FF0000?text=No+Image';
                  }}
                />
              </div>
            </div>
          ))}
        </div>
        
        {pagination && (
          <div className={styles.pagination}>
            <button
              className={styles.pageButton}
              onClick={prevPage}
              disabled={currentPage === 1}
            >
              Previous
            </button>
            <div className={styles.pageIndicator}>
              Page {pagination.current_page} of {pagination.pages}
            </div>
            <button
              className={`${styles.pageButton} ${styles.nextButton}`}
              onClick={nextPage}
              disabled={currentPage === pagination.pages}
            >
              Next Page
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default ReadMoreSeries;